export const defaultIconCategoryTags = Object.freeze([
  'children_shoes',
  'children_clothes',
  'wedding',
  'ventilation_heating_air_conditioning',
  'tablets',
  'ebook_readers',
  'tablet_accessories',
  'tablet_stickers',
  'tablet_bases',
  'miscellaneous_tablet_accessories',
  'tablet_cases',
  'tablet_batteries',
  'tablet_keyboards',
  'tablet_screen_protector',
  'power_supplies',
  'tablet_chargers',
  'game_controls',
  'deep_cool_base_and_cooling',
  'inverter_laptop',
  'usb_connectors',
  'fans',
  'laptop_parts',
  'laptop_skins',
  'bases_&_docking_stations',
  'power_supplies',
  'laptop_accessories',
  'repair_tools_for_laptop',
  'speakers',
  'pcmcia_cards',
  'screen_cable_tapes_lvds_cables',
  'power_boards',
  'laptop_hinges',
  'plastic_covers',
  'adapters_connections_cables',
  'laptop_keyboards',
  'laptop_screens',
  'spray',
  'laptop_power_adapters',
  'laptop_bags',
  'battery_chargers',
  'door_phones_video_door_phones',
  'projector',
  'portable_speakers_audio_systems',
  'headphones_headset',
  'consoles_accessories',
  'photographic_machines_with_film',
  'miscellaneous_accessories_&_gadgets',
  'virtual_reality_3d_headsets',
  'pa_amplifiers',
  'tvs',
  'laptop_accessories',
  'cordless_telephones',
  'tvs_smart_tv',
  'photovoltaic_batteries',
  'audio_systems',
  'playstation3',
  'dvd_&_blu_ray_movies',
  'converters',
  'dvd_&_blu_ray_movies',
  'pa_speakers',
  'miscellaneous_video_games',
  'photo_cameras',
  'video_cameras',
  'home_cinema_speakers_&_subwoofers',
  'film',
  'lens_accessories',
  'record_player',
  'dvd,_blu_ray_&_video',
  'wifi_repeater',
  'psp_games',
  'tvs_smart_tv',
  'electronics_energy_cables',
  'gaming_peripheral',
  'communication',
  'lighting_signs',
  'photovoltaics_&_wind_turbines',
  'photo_&_video',
  'sound'
])
